import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiServiceService} from '../api-service.service';
import {Params} from '@angular/router';

@Injectable()
export class ContactService {
    constructor(private httpClient: HttpClient, private apiService: ApiServiceService) {
    }

    public async save(userDetails: { name: string; email: string; phoneNumber: string; message: string }, metadata: Params): Promise<void> {
        const url = this.apiService.baseURL() + 'contact-us';
        const body = {
            name: userDetails.name,
            email: userDetails.email,
            phoneNumber: userDetails.phoneNumber,
            message: userDetails.message,
            metadata: metadata
        };
        await this.httpClient.post(url, body).toPromise();
    }
}